module.exports = __webpack_public_path__ + "media/images/ui__arrowDown--dark-1c804ffb27976cb63dd65295a2695cc0.png";